export default "__VITE_ASSET__BWgfOCkd__"